import ReactPlayer from 'react-player';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useAppStateContext } from '@/shared';
import { getContentPath, getTenantId } from '@/utils/functions';
import { PageLoading } from '@/shared/components/custom';
import { usePagePlayer } from '../hooks';
import 'animate.css';

const getPlayerScreen = (state, deviceInfo, getIdleImage) => {
  const { transitionEntry, transitionExit, playlistContents } =
    state.activeItem.playlist;
  const content = playlistContents[state.currentIndex].file;
  const fileInfo = JSON.parse(content.info);
  const contentUrl = getContentPath(getTenantId()) + content.fileName;
  const isVideoContent = fileInfo.ContentType.includes('video');
  return (
    <CSSTransition
      classNames={{
        enter: 'animate__animated',
        enterActive: transitionEntry ? transitionEntry : 'animate__fadeIn',
        exit: 'animate__animated',
        exitActive: transitionExit ? transitionExit : 'animate__fadeOut',
      }}
      timeout={1000}
      key={content.fileName}
    >
      {isVideoContent ? (
        <ReactPlayer
          url={contentUrl}
          className="object-contain absolute top-0 left-0 h-screen w-screen"
          height="100%"
          width="100%"
          playing
          muted
          loop
          playsinline
          onError={(err) => console.error('playback error', err)}
          config={{
            file: {
              attributes: {
                preload: 'auto', // ask browser to download ahead
                poster: getIdleImage(deviceInfo.orientation), // show poster before playback begins
                crossOrigin: 'anonymous',
              },
            },
          }}
        />
      ) : (
        <img
          className="object-contain absolute top-0 left-0 h-screen w-screen"
          alt="Content"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = deviceInfo && getIdleImage(deviceInfo.orientation);
          }}
          src={contentUrl}
        />
      )}
    </CSSTransition>
  );
};

export const PagePlayer = () => {
  const { appState } = useAppStateContext();
  const { state, getIdleImage } = usePagePlayer();

  const deviceInfo = appState.deviceInfo;

  const isPlayerContentAvailable =
    state.activeItem.scheduleId > 0 &&
    state.activeItem.playlist.playlistContents.length > 0 &&
    state.currentIndex < state.activeItem.playlist.playlistContents.length;

  return state.isBusy ? (
    <PageLoading text="Loading contents..." />
  ) : (
    <div className="w-screen h-screen bg-black overflow-hidden relative">
      {isPlayerContentAvailable ? (
        <TransitionGroup>
          {getPlayerScreen(state, deviceInfo, getIdleImage)}
        </TransitionGroup>
      ) : (
        <img
          alt="idle"
          className="h-screen w-screen object-contain"
          src={getIdleImage(deviceInfo.orientation)}
        />
      )}
    </div>
  );
};
